/**
 * @generated SignedSource<<7ba327901bde6343f0f8977263495a61>>
 * @relayHash 3005ddf30678cbf39055c070ff7f15ef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiFeaturesPlansSettingsQuery } from './uiFeaturesPlansSettingsQuery.graphql';

const node: PreloadableConcreteRequest<uiFeaturesPlansSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "44e5b4e28fbfa841edf74d46388681eb22eb60b2c617054dc398ec9b08607cea",
    "metadata": {},
    "name": "uiFeaturesPlansSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
